import axios from 'axios'
import { REST_ENDPOINT } from "@/constants";

const AUTH_TOKEN_KEY = 'authToken'

function getAuthToken() {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    axios.defaults.headers.common['X-Auth-Token'] = `${token}`;
    return token;
}

function setAuthToken(token) {
    axios.defaults.headers.common['X-Auth-Token'] = `${token}`;
    localStorage.setItem(AUTH_TOKEN_KEY, token);
}

function clearAuthToken() {
    axios.defaults.headers.common['X-Auth-Token'] = '';
    localStorage.removeItem(AUTH_TOKEN_KEY);
}

function verifyToken(token) {
    return new Promise( (resolve, reject) => {
        try {
            axios({
                url: `${REST_ENDPOINT}login.php`,
                method: 'POST',
                data: {
                    token: token
                }
            })
            .then(res => resolve({isLoggedIn: res.status === 200, token: res?.data?.token, role: res?.data?.role }))
            .catch(err => {
                if(err.response.status == 403) {
                    resolve({isLoggedIn: false, token: null, role: null});
                } else {
                    reject(err);
                }
            })
        } catch (err) {
            console.error('Caught an error during login:', err)
            reject(false)
        }
    })
}

export default {
    state: {
        isLoggedIn: false,
        authToken: getAuthToken(),
        role: null
    },
    mutations: {
        setLoggedIn(state, {isLoggedIn, token, role}) {
            state.isLoggedIn = isLoggedIn;
            state.role = isLoggedIn ? role : null;
            if (isLoggedIn) {
                state.authToken = token;
                setAuthToken(token);
            }
            else {
                state.authToken = null;
                clearAuthToken();
            }
        }
    },
    actions: {
        loginUser(context, user) {
            return new Promise( (resolve, reject) => {
                try {
                    axios({
                        url: `${REST_ENDPOINT}login.php`,
                        method: 'POST',
                        data: user
                    })
                    .then(res => {
                        context.commit('setLoggedIn', {isLoggedIn: true, token: res.data.token, role: res.data.role});
                        resolve();
                    }).catch(err => {
                        console.log('Caught an error during login:', err);
                        reject(err);
                    })
                } catch (err) {
                    console.error('Caught an error during login:', err);
                    reject(err);
                }
            })
        },
        logoutUser(context) {
            return new Promise( (resolve, reject) => {
                try{
                    axios({
                        url: `${REST_ENDPOINT}logout.php`,
                        method: 'POST',
                        data: { token: getAuthToken() }
                    })
                    .then(() => {
                        context.commit('setLoggedIn', {isLoggedIn: false});
                        resolve();
                    }).catch(err => {
                        console.log('Caught an error during logout:', err);
                        reject(err);
                    })
                } catch (err) {
                    console.error('Caught an error during logout:', err);
                    reject(err);
                }
            });
        },
        verifyLogin(context) {
            let authToken = getAuthToken();
            if (!authToken) {
                context.commit('setLoggedIn', {isLoggedIn: false});
                return new Promise(resolve => resolve(false));
            } else {
                return new Promise( (resolve, reject) => {
                    verifyToken(authToken)
                    .then(res => {
                        context.commit('setLoggedIn', {isLoggedIn: res.isLoggedIn, token: res.token, role: res.role});
                        resolve(res.isLoggedIn);
                    }).catch(reject);
                });
            }
        }
    },
    getters: {
        isLoggedIn: state => state.isLoggedIn,
        getRole: state => state.role,
        isAdmin: state => state.role === 'admin',
        authToken: state => state.authToken
    }
};
